'use client';

import dynamic from 'next/dynamic';

export const SidebarToggle = dynamic(() =>
  import('./sidebar-toggle.js').then((mod) => mod.SidebarToggle)
);
